const isValidFieldForFormData = (field, submitWithReadOnlyFields = false) => {
  if (field?.permission) {
    if (field?.permission === 'WRITE_ONCE') {
      return !field?.initialValue;
    }
    if (['READ', 'READ_ONLY'].includes(field?.permission)) {
      return submitWithReadOnlyFields;
    }
  }
  return !field.readOnly && !(field?.register === false);
};

export default isValidFieldForFormData;
